import React, { Fragment, useEffect, useState } from 'react';
import Navbar from '../layouts/Navbar';
import Footer from '../layouts/Footer';
import axios from 'axios';
import { useSelector } from 'react-redux';
import BlankImage from '../assets/Blank.png'
import { Skeleton } from '@mui/material'

const Executives = ()=>{
    const uri = useSelector(state=>state.uri)
    const [executives, setExecutives] = useState([])
    const [staffAdvisers, setStaffAdvisers] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [arr,] = useState([1,2,3,4])

    useEffect(()=>{
        axios.get(
            `${uri}executives`
        ).then(res=>{
            setExecutives(res.data.data.filter(each=>each.type !== 'staff'))
            setStaffAdvisers(res.data.data.filter(each=>each.type == 'staff'))
            setIsLoading(false)
        }).catch(err=>{
            setIsLoading(false)
            // setError(err.message)
        })
    }, [uri])
    return (
        <Fragment>
            <Navbar />
            <div className='mt-5 bg-executive container-fluid'>
                <div className='container pt-5'>
                    <div className='d-flex justify-content-center'>
                        <div className='col-md-6 pt-5'>
                            <p className='text-amazing text-center fw-bold fs-4 my-0'>
                                Patrons/Staff Advisers and Executive Members
                            </p>
                            <hr className='my-0 text-line' />
                        </div>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <p className='text-center text-white pt-md-4 pt-3 col-md-9' data-aos='fade-up'>
                            Meet our Patrons, Staff Advisers and amazing Executive members.
                        </p>
                    </div>
                    {
                        isLoading
                        ?
                        <div className='container-fluid bg-executive pb-2'>
                            <div className='row w-100 mx-auto pb-5'>
                                {arr.map((each, i)=>(
                                    <div key={i} className='col-lg-3 col-md-6 mb-4' data-aos='fade-up'>
                                        <div className='card bg-yrh'>
                                            <Skeleton variant='rectangular' height={300} />
                                            <div className='card-body border card-border rounded-4'>
                                                <Skeleton className='bg-skeleton-card' variant='text' />
                                                <Skeleton className='bg-skeleton-card' variant='text' />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        :
                        executives.length !== 0
                        ?
                        <div className='row w-100 mx-auto pb-5'>
                            {staffAdvisers.map((each, i)=>(
                                <div key={i} className='col-lg-3 col-md-6 mb-4' data-aos='fade-up'>
                                    <div className='card bg-yrh'>
                                        <img alt={i} src={!each.photo ? BlankImage : each.photo} className='card-img-top' />
                                        <div className='card-body border card-border rounded-4'>
                                            <p className='text-center text-white'>
                                                {!each.fullname ? 'Office Holder' : each.fullname}
                                            </p>
                                            <p className='card-text text-center fst-italic'>
                                                {each.office}
                                            </p>
                                            <p className='card-text text-center fst-italic'>
                                                {each.position}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {staffAdvisers.length !== 0 && <hr className='mb-4 text-line' />}
                            {executives.map((each, i)=>(
                                <div key={i} className='col-lg-3 col-md-6 mb-4' data-aos='fade-up'>
                                    <div className='card bg-yrh'>
                                        <img alt={i} src={!each.photo ? BlankImage : each.photo} className='card-img-top' />
                                        <div className='card-body border card-border rounded-4'>
                                            <p className='text-center text-white'>
                                                {!each.fullname ? 'Office Holder' : each.fullname}
                                            </p>
                                            <p className='card-text text-center fst-italic mb-0'>
                                                {each.office}
                                            </p>
                                            <p className='card-text text-center my-0 fs-7 fst-italic'>
                                                {each.deptLevel}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>                                
                        :
                        <div className='container-fluid bg-executive p-md-5 p-2'>
                            <p className='fs-5 text-white fst-italic'>
                                This page is currently unavailable, check back later...
                            </p>
                        </div>
                    }
                </div>     
            </div>
            <Footer />
        </Fragment>
    )
}

export default Executives